import { actionCreatorFactory } from "typescript-fsa";
import { AutoConf, ResultList, Search } from "core/types/search.types";

const actionCreator = actionCreatorFactory("search");

export const resetSearch = actionCreator<void>("RESET");

export const search = actionCreator<{ search: Search }>("SEARCH_SUCCESS");

export const isSearchLoading = actionCreator<{ isSearchLoading: boolean }>(
  "IS_SEARCH_LOADING"
);

export const resultList = actionCreator<{ resultList: ResultList[] }>(
  "RESULT_LIST"
);

export const resultDetail = actionCreator<{
  resultDetail: Search | undefined;
}>("RESULT_DETAIL");

export const isAutoLoading = actionCreator<{ isAutoLoading: boolean }>(
  "IS_AUTO_LOADING"
);

export const automaticConfigElements = actionCreator<{
  automaticConfigElements: AutoConf;
}>("AUTO_CONF_ELEM");

export const success = actionCreator<{ success: string }>("AUTO_SUCCESS");

export const error = actionCreator<{ error: string }>("AUTO_ERROR");
